import { ToastConfig, ToastType } from '@hevoio/hevo-ui-toolkit';
import { BehaviorSubject } from 'rxjs';
export class ToasterService {
  public addToastSubject = new BehaviorSubject<ToastConfig>(null);

  pop(type: ToastType | ToastConfig, title?: string, body?: string) {
    const toast = typeof type === 'string' ? { type: type, title: title, body: body } : type;

    this.addToastSubject.next(toast);
  }
}
